export default {
    home: '/',
    listFoodGroup: '/food/group',
    listFood: '/foods',
    cartDetail: '/cart-detail',
    notFound: '/not-found',
    unSupport: '/unsupport',

    register: '/register',
    updateProfile: '/update-profile',
    forgotPassword: '/forgot-password',
    updatePassword: '/update-password',
    resetPassword: '/reset-password',

    orderHistory: '/order/history',
    orderDetails: '/order/details',
    verifyTable: '/verify-table',
    verifyQRCode: '/verify-qrcode',
    tableQRcodeSuccess: '/qrcode-success',
}

// backup
// export default {
//     home: '/',
//     listFoodGroup: '/list-food-group',
//     listFood: '/list-food',
//     cartDetail: '/cart-detail',
//     foodDetail: '/food-detail',
//     notFound: '/not-found',

//     register: '/register',
//     updateProfile: '/update-profile',
//     forgotPassword: '/forgot-password',
//     updatePassword: '/update-password',
//     resetPassword: '/reset-password',

//     orderHistory: '/order/history',
//     orderDetails: '/order/details',
// }
